import React, { useState, useEffect } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from '../../composant_reutilisable/useAuth';
import { Link, useNavigate } from "react-router-dom";
import { FaPlus, FaShieldAlt, FaTrash, FaEdit, FaSortAmountUp, FaSortAmountDown, FaArrowLeft, FaEllipsisV, FaArrowRight, FaChevronDown, FaCheck, FaTruckLoading, FaUpload, FaBus, FaTruck, FaQuestionCircle, FaChevronUp } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";
import { FaEyeSlash, FaFreebsd, FaRegEye, FaTruckDroplet } from "react-icons/fa6";
import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import Pas_acces from "../../composant_reutilisable/pas_acces";
import axios from "axios";

const Enrolement_archives = ({ titre }) => {
    useAuth();
    const user_id = localStorage.getItem("userId");
    const [isLoading, setIsLoading] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const navigate = useNavigate();

    const [showInfo, setShowInfo] = useState(false);

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Listes Enrolements";
        }
    }, [user_id]);

    //const [filteredEnrolements, setFilteredEnrolements] = useState([]);

    // États
    const [userData, setUserData] = useState({});
    const [listeEnrolement, setListeEnrolement] = useState([]);

    // États pour la recherche et la pagination
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [openDropdownId, setOpenDropdownId] = useState(null);

    // État pour suivre l'utilisateur sélectionné
    const [enrolementSelectionne, setEnrolementSelectionne] = useState(null);
    const [deleteEnrolement, setDeleteEnrolement] = useState(null);
    const [restoreEnrolement, setRestoreEnrolement] = useState(null);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 3000);
    };

    // Récupérer les données de l'utilisateur
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                setIsLoading(true);
                const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setUserData(data);
                }
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                console.error("Erreur lors de la récupération du profil:", error);
            }
        };

        fetchUserData();
    }, [user_id]);

    // Récupérer la liste des enrolements archivés
    const fetchEnrolements = async () => {
        try {
            console.log("Début de la requête fetch...");
            const response = await fetch(process.env.REACT_APP_HOTE + "/listes-enrolements-archives/");

            if (response.ok) {
                console.log("Réponse OK, récupération des données...");
                const data = await response.json();
                console.log("Données récupérées:", data); // Affiche l'objet complet
                setListeEnrolement(data);
                console.log("Liste des véhicules:", data); // Affiche les véhicules
            } else {
                console.log("Erreur dans la réponse:", response.status);
            }

        } catch (error) {
            console.error("Erreur lors de la récupération des enrolements:", error);
        }
    };
    useEffect(() => {
        console.log("Exécution de useEffect...");
        fetchEnrolements();
    }, []);

    // Filter enrolements by search term
    const filteredEnrolements = listeEnrolement.filter(n =>
        (n.numero_immatriculation && n.numero_immatriculation.toLowerCase().includes(searchTerm.toLowerCase())) ||
        //(n.numero_chassis && n.numero_chassis.toLowerCase().includes(searchTerm.toLowerCase())) ||
        // (n.marque && n.marque.toLowerCase().includes(searchTerm.toLowerCase())) ||
        // (n.date_circulation && n.date_circulation.toString().includes(searchTerm.toLowerCase())) ||
        // (n.nombre_essieux && n.nombre_essieux.toString().includes(searchTerm.toLowerCase())) ||
        // (n.genre && n.genre.genre && n.genre.genre.toLowerCase().includes(searchTerm.toLowerCase())) || // Vérification de null pour n.genre
        (n.type_vehicule && n.type_vehicule.toLowerCase().includes(searchTerm.toLowerCase())) ||
        // (n.poids_vide && n.poids_vide.toString().includes(searchTerm.toLowerCase())) ||
        // (n.poids_total && n.poids_total.toString().includes(searchTerm.toLowerCase())) ||
        // (n.charge_utile && n.charge_utile.toString().includes(searchTerm.toLowerCase())) ||
        (n.proprietaire && n.proprietaire.toLowerCase().includes(searchTerm.toLowerCase())) ||
        //(n.email_proprietaire && n.email_proprietaire.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (n.telephone && n.telephone.toString().includes(searchTerm.toLowerCase())) ||
        // (n.numero_npi && n.numero_npi.toString().includes(searchTerm.toLowerCase())) ||
        // (n.numero_ifu && n.numero_ifu.toString().includes(searchTerm.toLowerCase())) ||
        // (n.numero_cip && n.numero_cip.toString().includes(searchTerm.toLowerCase())) ||
        // (n.numero_police && n.numero_police.toString().includes(searchTerm.toLowerCase())) ||
        // (n.nationalite_proprietaire && n.nationalite_proprietaire.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (n.nationalite_vehicule && n.nationalite_vehicule.toLowerCase().includes(searchTerm.toLowerCase())) ||
        // (n.numero_cartegrise && n.numero_cartegrise.toString().includes(searchTerm.toLowerCase())) ||
        // (n.datefin_tvm && n.datefin_tvm.toString().includes(searchTerm.toLowerCase())) ||
        // (n.datedebut_tvm && n.datedebut_tvm.toString().includes(searchTerm.toLowerCase())) ||
        // (n.numero_tvm && n.numero_tvm.toString().includes(searchTerm.toLowerCase())) ||
        (n.fin_cartetransport && n.fin_cartetransport.toString().includes(searchTerm.toLowerCase())) ||
        //(n.debut_cartetransport && n.debut_cartetransport.toString().includes(searchTerm.toLowerCase())) ||
        // (n.fin_visite && n.fin_visite.toString().includes(searchTerm.toLowerCase())) ||
        // (n.debut_visite && n.debut_visite.toString().includes(searchTerm.toLowerCase())) ||
        // (n.numero_visite && n.numero_visite.toString().includes(searchTerm.toLowerCase())) ||
        // (n.fin_assurance && n.fin_assurance.toString().includes(searchTerm.toLowerCase())) ||
        // (n.debut_assurance && n.debut_assurance.toString().includes(searchTerm.toLowerCase())) ||
        // (n.assureur && n.assureur.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (n.ajoute_par && n.ajoute_par.toLowerCase().includes(searchTerm.toLowerCase()))
            (n.reference_carte && n.reference_carte.toLowerCase().includes(searchTerm.toLowerCase()))

    );

    // Pagination
    const totalItems = filteredEnrolements.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const enrolementsAffiches = filteredEnrolements.slice(indexOfFirstItem, indexOfLastItem);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // const handleSelectionEnrolement = (user) => {
    //     setEnrolementSelectionne(user);
    // };

    // Fonction de suppression
    const handleSupprimer = async () => {

        try {
            //console.log(`Envoi de la requête de suppression pour le véhicule avec ID: ${deleteEnrolement.id}`);

            const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-vehicule/${deleteEnrolement.id}/${user_id}/`, {
                method: "DELETE",
            });

            if (response.ok) {
                //console.log(`Réponse OK reçue pour la suppression du véhicule: ${deleteEnrolement.id}`);

                // Mise à jour de la liste des enrolements après suppression
                setListeEnrolement(listeEnrolement.filter(u => u.id !== deleteEnrolement.id));
                console.log("Liste des enrolements mise à jour après supression:", listeEnrolement);
                setShowModal(false);
                // Affichage du message de confirmation
                showAlert(`L'enrolement du vehicule matriculé ${deleteEnrolement.numero_immatriculation} supprimé avec succès`, "success");

                // Réinitialisation de la sélection
                setDeleteEnrolement(null);
            } else {
                //console.log(`Erreur lors de la suppression de l'utilisateur ${deleteEnrolement.numero_immatriculation}. Statut de la réponse: ${response.status}`);
                showAlert(`Erreur lors de la suppression de l'utilisateur ${deleteEnrolement.numero_immatriculation}.`, "danger");
            }
        } catch (error) {
            console.error("Erreur réseau lors de la supression:", error);
            showAlert("Une erreur s'est produite lors de la supression. Veuillez réessayer.", "danger");
        }
    };

    const handleRestaurer = async () => {

        try {
            //console.log(`Envoi de la requête de suppression pour le véhicule avec ID: ${deleteEnrolement.id}`);

            const response = await fetch(`${process.env.REACT_APP_HOTE}/restaurer-vehicule/${restoreEnrolement.id}/${user_id}/`, {
                method: "DELETE",
            });

            if (response.ok) {
                //console.log(`Réponse OK reçue pour la suppression du véhicule: ${deleteEnrolement.id}`);

                // Mise à jour de la liste des enrolements après suppression
                setListeEnrolement(listeEnrolement.filter(u => u.id !== restoreEnrolement.id));
                console.log("Liste des enrolements mise à jour après restauration:", listeEnrolement);
                setShowRestoreModal(false);
                // Affichage du message de confirmation
                showAlert(`L'enrolement du vehicule matriculé ${restoreEnrolement.numero_immatriculation} restauré avec succès`, "success");

                // Réinitialisation de la sélection
                setRestoreEnrolement(null);
            } else {
                //console.log(`Erreur lors de la suppression de l'utilisateur ${restoreEnrolement.numero_immatriculation}. Statut de la réponse: ${response.status}`);
                showAlert(`Erreur lors de la restauration de l'utilisateur ${restoreEnrolement.numero_immatriculation}.`, "danger");
            }
        } catch (error) {
            console.error("Erreur réseau lors de la restauration:", error);
            showAlert("Une erreur s'est produite lors de la restauration. Veuillez réessayer.", "danger");
        }
    };

    const handleValider = async (vehicule_id) => {
        console.log("▶️ Début de la fonction handleValider pour le véhicule ID :", vehicule_id);

        try {
            console.log("🚀 Envoi de la requête à :", `${process.env.REACT_APP_HOTE}/valider-enrolement/${vehicule_id}/`);

            const response = await fetch(`${process.env.REACT_APP_HOTE}/valider-enrolement/${vehicule_id}/`, {
                method: "POST",
                headers: {
                    // Si ton backend Django utilise CSRF
                },
            });

            console.log("📬 Réponse reçue :", response);

            const responseData = await response.json(); // Convertir la réponse en JSON

            if (response.ok) {
                console.log("✅ Véhicule validé avec succès !");
                showAlert(responseData.message || "Véhicule validé avec succès !", "success");
                navigate(`/Liste-enrolement`);
            } else {
                console.log("❌ La validation du véhicule a échoué.");
                console.error("🛑 Erreur API :", responseData);
                showAlert(responseData.error || "Erreur lors de la validation.", "danger");
            }
        } catch (error) {
            console.error("🌐 Erreur réseau :", error);
            showAlert("Erreur réseau. Veuillez réessayer.", "danger");
        }
    };

    const [showModal, setShowModal] = useState(false);
    const [showRestoreModal, setShowRestoreModal] = useState(false);
    const [selectedRole, setSelectedRole] = useState(""); // Stocke le rôle sélectionné
    const [selected, setSelected] = useState(""); // Stocke le rôle sélectionné

    const handleOpenModal = (n) => {
        setDeleteEnrolement(n);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedRole(""); // Réinitialiser après fermeture
        setAlert({ message: '', type: '' });
    };

    const handleOpenRestoreModal = (n) => {
        setRestoreEnrolement(n);
        setShowRestoreModal(true);
    };

    const handleCloseRestoreModal = () => {
        setShowRestoreModal(false);
        setSelected(""); // Réinitialiser après fermeture
        setAlert({ message: '', type: '' });
    };



    // const handleRowClick = (n) => {
    //     console.log(n);  // Vérifiez ce que contient n lorsque vous cliquez sur une ligne
    //     handleModifier(n);
    // };

    const handleModifier = (n) => {
        console.log(n);
        if (n && n.id) {
            navigate(`/Modifier-enrolement`, {
                state: { vehicule_id: n.id },
            });
        } else {
            console.error("Véhicule ou ID manquant :", n.id);
        }
    };

    // const handleRowClick = (n) => {
    //     if (enrolementSelectionne && enrolementSelectionne.id === n.id) {
    //         setEnrolementSelectionne(null); // Désélectionner la ligne
    //     } else {
    //         setEnrolementSelectionne(n); // Sélectionner la ligne
    //     }
    // };

    const [showColumnSelector, setShowColumnSelector] = useState(false);

    const [visibleColumns, setVisibleColumns] = useState({
        numero_immatriculation: true,
        numero_chassis: false,
        marque: false,
        date_circulation: false,
        nombre_essieux: false,
        genre: false,
        type_vehicule: true,
        poids_vide: false,
        poids_total: false, // Masqué par défaut
        charge_utile: false,
        proprietaire: true,
        email_proprietaire: false,
        telephone: true,
        numero_npi: false,
        numero_ifu: false,
        numero_cip: false,
        numero_police: false,
        nationalite_proprietaire: false,
        nationalite_vehicule: true,
        numero_cartegrise: false,
        datefin_tvm: false,
        datedebut_tvm: false,
        numero_tvm: false,
        fin_cartetransport: true,
        debut_cartetransport: false,
        reference_carte: true,
        fin_visite: false,
        debut_visite: false,
        numero_visite: false,
        datefin_assurance: false,
        datedebut_assurance: false,
        assureur: false,
        ajoute_par: true,
    });

    const ColumnSelector = ({ visibleColumns, setVisibleColumns }) => {
        const columns = [
            { key: "numero_immatriculation", label: "Numero matricule" },
            { key: "numero_chassis", label: "Numero du Chassis" },
            { key: "marque", label: "Marque" },
            { key: "date_circulation", label: "Date de mise en Circulation" },
            // { key: "serie_moteur", label: "Serie moteur" },
            { key: "nombre_essieux", label: "Nombre Essieux" },
            { key: "genre", label: "Genre" },
            { key: "type_vehicule", label: "Type de Vehicule" },
            { key: "poids_vide", label: "Poids Vide" },
            { key: "poids_total", label: "Poids Total" },
            { key: "charge_utile", label: "Charge Utile" },
            { key: "proprietaire", label: "Prénoms du propriétaire" },
            { key: "email_proprietaire", label: "Email du propriétaire" },
            { key: "telephone", label: "Telephone" },
            { key: "numero_npi", label: "Numero NPI" },
            { key: "numero_ifu", label: "Numero IFU" },
            { key: "numero_cip", label: "Numero CIP" },
            { key: "numero_police", label: "Numero POLICE" },
            { key: "nationalite_proprietaire", label: "Nationalité du propriétaire" },
            { key: "nationalite_vehicule", label: "Nationalité du véhicule" },
            { key: "numero_cartegrise", label: "Carte Grise" },
            { key: "datefin_tvm", label: "Date Fin TVM" },
            { key: "datedebut_tvm", label: "Date Debut TVM" },
            { key: "numero_tvm", label: "Numero TVM" },
            { key: "fin_cartetransport", label: "Date Fin Carte Transport" },
            { key: "debut_cartetransport", label: "Date Debut Carte Transport" },
            { key: "reference_carte", label: "Référence de la Carte Transport" },
            { key: "fin_visite", label: "Date Fin Visite Technique" },
            { key: "debut_visite", label: "Date Debut Visite Technique" },
            { key: "numero_visite", label: "Numéro Visite Technique" },
            { key: "datefin_assurance", label: "Date Fin Assurance" },
            { key: "datedebut_assurance", label: "Date Debut Assurance" },
            { key: "assureur", label: "Assureur" },
            { key: "ajoute_par", label: "Ajouté par" },
        ];

        const handleToggleColumn = (key) => {
            setVisibleColumns((prev) => ({
                ...prev,
                [key]: !prev[key], // Bascule la visibilité de la colonne
            }));
        };

        return (
            <div className="dropdown">
                <button
                    className="form-select bg-default p-1"
                    style={{
                        width: "auto",
                        border: "1px black solid",
                        borderRadius: "5px",
                        backgroundColor: "transparent", // Fond transparent
                    }}
                    type="button"
                    id="dropdownMenuButton"
                    onClick={() => setShowColumnSelector(!showColumnSelector)}
                >
                    Visibilité des colonnes
                    <FaChevronDown className="ms-2" size={12} />
                </button>
                {showColumnSelector && (
                    <div
                        className="dropdown-menu show"
                        aria-labelledby="dropdownMenuButton"
                    >
                        {columns.map((column) => (
                            <button
                                key={column.key}
                                className="dropdown-item"
                                onClick={() => handleToggleColumn(column.key)}
                            >
                                {column.label} {visibleColumns[column.key] && <span>✓</span>}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    const formatValue = (value) => {
        if (value === null || value === undefined || value === 'None') {
            return "Non renseigné"; // Ou "" pour une valeur vide
        }
        return value;
    };

    const [showGlossary, setShowGlossary] = useState(false);

    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Corbeille")) {
        return (
            <Pas_acces />
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2></h2>
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaTruck size={25} className='mr-2' />Corbeilles des enrôlements
                                    {/* <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span> */}
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'admin-corbeille'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                                <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button>
                            </h2>
                            <small>Corbeilles des enrôlements.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Corbeilles`}> Corbeilles</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Corbeilles des enrôlements
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des enrôlements archivés</h5>
                                <div className="d-flex flex-column flex-md-row">
                                    {/* <Link to={`/Enroler-vehicule`} className="btn btn-success mr-2 ms-0 mb-2 mb-md-0 ms-md-2">
                                        <FaPlus /> Enrôler
                                    </Link> */}
                                    {/* <button
                                        onClick={handleOpenModal}
                                        disabled={!enrolementSelectionne}
                                        className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${enrolementSelectionne ? 'btn-success' : 'btn-default text-dark disabled'}`}
                                    >
                                        <FaTrash /> Supprimer
                                    </button>
                                    <button
                                        onClick={handleModifier}
                                        disabled={!enrolementSelectionne}
                                        className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${enrolementSelectionne ? 'btn-success' : 'btn-default text-dark disabled'}`}
                                    >
                                        <FaEdit /> Modifier
                                    </button> */}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2 d-flex ">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{
                                                            width: "auto",
                                                            border: "1px black solid",
                                                            borderRadius: "5px",
                                                        }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>

                                                    {/* Sélecteur de colonnes */}
                                                    {/* <div className="ml-2">
                                                        <ColumnSelector
                                                            visibleColumns={visibleColumns}
                                                            setVisibleColumns={setVisibleColumns}
                                                        />
                                                    </div> */}
                                                </div>

                                                <div className="d-flex align-items-center ">
                                                    <input
                                                        type="text"
                                                        placeholder="Rechercher..."
                                                        className="form-control"
                                                        style={{ maxWidth: "150px", width: "100%" }}
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                <table
                                                    className="footable table table-stripped footable-loaded tablet breakpoint"
                                                    data-page-size="8"
                                                    data-filter="#filter"
                                                >
                                                    <thead>
                                                        <tr>
                                                            {visibleColumns.numero_immatriculation && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                    onClick={() => handleSort("numero_immatriculation")}
                                                                >
                                                                    Immatriculation{" "}
                                                                    {sortConfig.key === "numero_immatriculation"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.nationalite_vehicule && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                    onClick={() => handleSort("nationalite_vehicule")}
                                                                >
                                                                    Nationalité {sortConfig.key === "nationalite_vehicule"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.type_vehicule && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                    onClick={() => handleSort("type_vehicule")}
                                                                >
                                                                    Type vehicule{sortConfig.key === "type_vehicule"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.proprietaire && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                    onClick={() => handleSort("proprietaire")}
                                                                >
                                                                    Propriétaire {sortConfig.key === "proprietaire"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.telephone && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                    onClick={() => handleSort("telephone")}
                                                                >
                                                                    Télephone {sortConfig.key === "telephone"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.reference_carte && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                    onClick={() => handleSort("reference_carte")}
                                                                >
                                                                    Carte transport {sortConfig.key === "reference_carte"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.fin_cartetransport && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                    onClick={() => handleSort("fin_cartetransport")}
                                                                >
                                                                    Date expiration{sortConfig.key === "fin_cartetransport"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}

                                                            {/* {visibleColumns.numero_chassis && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("numero_chassis")}
                                                                >
                                                                    Numero Chassis{sortConfig.key === "numero_chassis"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.marque && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("marque")}
                                                                >
                                                                    Marque {sortConfig.key === "marque"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.date_circulation && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("date_circulation")}
                                                                >
                                                                    Date de Mise en Circulation{sortConfig.key === "date_circulation"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.nombre_essieux && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("nombre_essieux")}
                                                                >
                                                                    Nombre Essieux {sortConfig.key === "nombre_essieux"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.genre && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("genre")}
                                                                >
                                                                    Genre {sortConfig.key === "genre"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.poids_vide && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("poids_vide")}
                                                                >
                                                                    Poids Vides{" "}
                                                                    {sortConfig.key === "poids_vide"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.poids_total && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("poids_total")}
                                                                >
                                                                    Poids Total{" "}
                                                                    {sortConfig.key === "poids_total"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.charge_utile && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("charge_utile")}
                                                                >
                                                                    Charge utile {sortConfig.key === "charge_utile"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.email_proprietaire && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("email_proprietaire")}
                                                                >
                                                                    Email {sortConfig.key === "email_proprietaire"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.numero_npi && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("numero_npi")}
                                                                >
                                                                    Numero NPI {sortConfig.key === "numero_npi"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.numero_ifu && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("numero_ifu")}
                                                                >
                                                                    Numero IFU {sortConfig.key === "numero_ifu"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.numero_cip && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("numero_cip")}
                                                                >
                                                                    Numero CIP {sortConfig.key === "numero_cip"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.numero_police && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("numero_police")}
                                                                >
                                                                    Numero POLICE {sortConfig.key === "numero_police"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.nationalite_proprietaire && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("nationalite_proprietaire")}
                                                                >
                                                                    Nationalité propriétaire {sortConfig.key === "nationalite_proprietaire"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.numero_cartegrise && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("numero_cartegrise")}
                                                                >
                                                                    Carte Grise {sortConfig.key === "numero_cartegrise"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.datefin_tvm && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("datefin_tvm")}
                                                                >
                                                                    Date Fin TVM {sortConfig.key === "datefin_tvm"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.datedebut_tvm && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("datedebut_tvm")}
                                                                >
                                                                    Date Debut Fin {sortConfig.key === "datedebut_tvm"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.numero_tvm && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("numero_tvm")}
                                                                >
                                                                    Numero TVM {sortConfig.key === "numero_tvm"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.debut_cartetransport && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("debut_cartetransport")}
                                                                >
                                                                    Date Debut Carte Transport {sortConfig.key === "debut_cartetransport"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.fin_visite && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("fin_visite")}
                                                                >
                                                                    Date Fin Visite {sortConfig.key === "fin_visite"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.debut_visite && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("debut_visite")}
                                                                >
                                                                    Date Debut Visite {sortConfig.key === "debut_visite"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.numero_visite && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("numero_visite")}
                                                                >
                                                                    Numero Visite {sortConfig.key === "numero_visite"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.datefin_assurance && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("datefin_assurance")}
                                                                >
                                                                    Date Fin Assurance {sortConfig.key === "datefin_assurance"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.datedebut_assurance && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("datedebut_assurance")}
                                                                >
                                                                    Date Debut Assurance {sortConfig.key === "datedebut_assurance"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.assureur && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell"
                                                                    onClick={() => handleSort("assureur")}
                                                                >
                                                                    Assureur {sortConfig.key === "assureur"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )} */}
                                                            {visibleColumns.ajoute_par && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                    onClick={() => handleSort("ajoute_par")}
                                                                >
                                                                    Ajouté par {sortConfig.key === "ajoute_par"}
                                                                    {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )}
                                                                </th>
                                                            )}
                                                            {visibleColumns.actions && (
                                                                <th
                                                                    className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                    onClick={() => handleSort("actions")}
                                                                >
                                                                    Actions {sortConfig.key === "actions"}
                                                                    {/* {sortConfig.direction === "ascending" ? (
                                                                        <FaSortAmountUp />
                                                                    ) : (
                                                                        <FaSortAmountDown />
                                                                    )} */}
                                                                </th>
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    {!isLoading ? (
                                                        <tbody>
                                                            {enrolementsAffiches.length > 0 ? (
                                                                enrolementsAffiches.map((n) => (
                                                                    <tr
                                                                        key={n.id}
                                                                        className={`${enrolementSelectionne && enrolementSelectionne.id === n.id ? "btn-primary text-white" : ""}`}
                                                                    // onClick={() => handleRowClick(n)}
                                                                    >
                                                                        {visibleColumns.numero_immatriculation && <td className="text-center">{n.numero_immatriculation}</td>}
                                                                        {visibleColumns.nationalite_vehicule && <td className="text-center">{n.nationalite_vehicule}</td>}
                                                                        {visibleColumns.type_vehicule && <td className="text-center">{n.type_vehicule}</td>}
                                                                        {visibleColumns.proprietaire && <td className="text-center">{n.proprietaire === 'None None' ? 'Non défini' : n.proprietaire}</td>}
                                                                        {visibleColumns.telephone && <td className="text-center">{n.telephone}</td>}
                                                                        {visibleColumns.reference_carte && <td className="text-center">{n.reference_carte ? n.reference_carte : "Non défini"}</td>}
                                                                        {visibleColumns.fin_cartetransport && <td className="text-center">{n.fin_cartetransport ? new Date(n.fin_cartetransport).toLocaleDateString() : "Non défini"}</td>}
                                                                        {visibleColumns.ajoute_par && <td className="text-center">{n.ajoute_par}</td>}


                                                                        {/* {visibleColumns.numero_chassis && <td>{n.numero_chassis}</td>}
                                                                        {visibleColumns.marque && <td>{n.marque}</td>}
                                                                        {visibleColumns.date_circulation && <td>{n.date_circulation}</td>}
                                                                        {visibleColumns.nombre_essieux && <td>{n.nombre_essieux}</td>}
                                                                        {visibleColumns.genre && <td>{n.genre}</td>}
                                                                        {visibleColumns.poids_vide && <td>{n.poids_vide}</td>}
                                                                        {visibleColumns.poids_total && <td>{n.poids_total}</td>}
                                                                        {visibleColumns.charge_utile && <td>{n.charge_utile}</td>}
                                                                        {visibleColumns.email_proprietaire && <td>{n.email_proprietaire}</td>}
                                                                        {visibleColumns.numero_npi && <td>{n.numero_npi}</td>}
                                                                        {visibleColumns.numero_ifu && <td>{n.numero_ifu}</td>}
                                                                        {visibleColumns.numero_cip && <td>{n.numero_cip}</td>}
                                                                        {visibleColumns.numero_police && <td>{n.numero_police}</td>}
                                                                        {visibleColumns.nationalite_proprietaire && <td>{n.nationalite_proprietaire}</td>}
                                                                        {visibleColumns.numero_cartegrise && <td>{n.numero_cartegrise}</td>}
                                                                        {visibleColumns.datefin_tvm && <td>{n.datefin_tvm}</td>}
                                                                        {visibleColumns.datedebut_tvm && <td>{n.datedebut_tvm}</td>}
                                                                        {visibleColumns.numero_tvm && <td>{n.numero_tvm}</td>}
                                                                        {visibleColumns.debut_cartetransport && <td>{n.debut_cartetransport}</td>}
                                                                        {visibleColumns.fin_visite && <td>{n.fin_visite}</td>}
                                                                        {visibleColumns.debut_visite && <td>{n.debut_visite}</td>}
                                                                        {visibleColumns.numero_visite && <td>{n.numero_visite}</td>}
                                                                        {visibleColumns.datefin_assurance && <td>{n.datefin_assurance}</td>}
                                                                        {visibleColumns.datedebut_assurance && <td>{n.datedebut_assurance}</td>}
                                                                        {visibleColumns.assureur && <td>{n.assureur}</td>} */}

                                                                        <td className="text-center" style={{ position: 'relative' }}>
                                                                            {/* Conditionner l'affichage de l'icône de modification */}
                                                                            {/* {n.statut !== "valide" && (
                                                                                <FaEdit
                                                                                    className="mr-2"
                                                                                    style={{ cursor: "pointer", color: "blue" }}
                                                                                    onClick={() => handleModifier(n)}
                                                                                />
                                                                            )}

                                                                            <FaTrash
                                                                                className=""
                                                                                style={{ cursor: "pointer", color: "red" }}
                                                                                onClick={() => handleOpenModal(n)}
                                                                            />
                                                                            <FaCheck
                                                                                className="ml-2"
                                                                                style={{ cursor: "pointer", color: "green" }}
                                                                                onClick={() => handleValider(n.id)}
                                                                            /> */}
                                                                            <div>
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setOpenDropdownId(openDropdownId === n.id ? null : n.id);
                                                                                    }}
                                                                                    style={{
                                                                                        background: 'none',
                                                                                        border: 'none',
                                                                                        padding: '0 5px',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                >
                                                                                    <FaEllipsisV
                                                                                        title="Actions"
                                                                                    />
                                                                                </button>

                                                                                {openDropdownId === n.id && (
                                                                                    <div
                                                                                        // ref={dropdownRef}
                                                                                        style={{
                                                                                            position: 'fixed',
                                                                                            zIndex: 1000,
                                                                                            minWidth: '60px',
                                                                                            right: '50px',
                                                                                            backgroundColor: 'white',
                                                                                            border: '1px solid #ddd',
                                                                                            borderRadius: '4px',
                                                                                            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                                                                            maxHeight: '150px',
                                                                                            overflowY: 'auto',
                                                                                            // Style personnalisé pour la scrollbar
                                                                                            scrollbarWidth: 'thin',
                                                                                            scrollbarColor: '#ddd #f8f9fa',
                                                                                        }}
                                                                                        className="custom-scrollbar"
                                                                                    >

                                                                                        <div
                                                                                            style={{
                                                                                                padding: '8px 16px',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                cursor: 'pointer',
                                                                                                ':hover': {
                                                                                                    backgroundColor: '#f8f9fa'
                                                                                                }
                                                                                            }}
                                                                                            onClick={() => handleModifier(n)}
                                                                                        >
                                                                                            <FaRegEye className="mr-2" style={{ color: "blue" }} size={14} />
                                                                                            <span>Consulter</span>
                                                                                        </div>

                                                                                        <div style={{ borderTop: '1px solid #eee' }} />
                                                                                        <div
                                                                                            style={{
                                                                                                padding: '8px 16px',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                cursor: 'pointer',
                                                                                                ':hover': {
                                                                                                    backgroundColor: '#f8f9fa'
                                                                                                }
                                                                                            }}
                                                                                            onClick={() => handleOpenModal(n)}
                                                                                        >
                                                                                            <FaTrash className="mr-2" style={{ color: "red" }} size={14} />
                                                                                            <span>Supprimer</span>
                                                                                        </div>

                                                                                        <div style={{ borderTop: '1px solid #eee' }} />

                                                                                        <div
                                                                                            style={{
                                                                                                padding: '8px 16px',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                cursor: 'pointer',
                                                                                                ':hover': {
                                                                                                    backgroundColor: '#f8f9fa'
                                                                                                }
                                                                                            }}
                                                                                            onClick={() => handleOpenRestoreModal(n)}
                                                                                        >
                                                                                            <FaUpload className="mr-2" style={{ color: "green" }} size={14} />
                                                                                            <span>Restaurer</span>
                                                                                        </div>

                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr className="text-center text-muted">
                                                                    <td className="" colSpan="8">Aucun enrôlement disponible</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    ) : (
                                                        <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                                            <span
                                                                className="spinner-border spinner-border-lg text-success"
                                                                role="status"
                                                                aria-hidden="true"
                                                                style={{ width: '3rem', height: '3rem' }}
                                                            ></span>
                                                        </div>
                                                    )}
                                                </table>
                                            </div>
                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div
                                                    className="dataTables_info"
                                                    role="status"
                                                    aria-live="polite"
                                                >
                                                    {totalItems === 0
                                                        ? ""
                                                        : `Élément ${indexOfFirstItem + 1} à ${Math.min(
                                                            indexOfLastItem,
                                                            totalItems
                                                        )} sur ${totalItems}`}
                                                </div>

                                                <div>
                                                    <button
                                                        onClick={handlePreviousPage}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                                        <button
                                                            key={page}
                                                            onClick={() => handlePageChange(page)}
                                                            className={`btn ${currentPage === page ? "bg-secondary" : "bg-success"} mx-1`}
                                                        >
                                                            {page}
                                                        </button>
                                                    ))}

                                                    <button
                                                        onClick={handleNextPage}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer text-center">
                        {/* <div className="float-right">
                        10GB of <strong>250GB</strong> Free.
                    </div> */}
                        <div>
                            <strong><a href="https://www.adnservicespro.com/" target="_blank" rel="noopener noreferrer">ADN Services</a></strong> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer">INOVACT SARL</a>
                        </div>
                    </div>

                    {/* Modal de confirmation de suppression */}
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la suppression</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Êtes-vous sûr de vouloir supprimer ce vehicule immatriculé <strong>{deleteEnrolement?.numero_immatriculation}</strong> ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                <strong>Annuler</strong>

                            </Button>
                            <Button variant="success" onClick={handleSupprimer}>
                                <strong>Supprimer</strong>

                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal de confirmation de restauration */}
                    <Modal show={showRestoreModal} onHide={handleCloseRestoreModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la restauration</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Voulez-vous restaurer ce vehicule immatriculé <strong>{restoreEnrolement?.numero_immatriculation}</strong> ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseRestoreModal}>
                                <strong>Annuler</strong>

                            </Button>
                            <Button variant="success" onClick={handleRestaurer}>
                                <strong>Restaurer</strong>

                            </Button>
                        </Modal.Footer>
                    </Modal>

                </div>
            </div>
            <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
        </div>
    );
};

export default Enrolement_archives;
